import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Navbar() {
  const activeClass = "text-blue-700 font-semibold underline";
  const normalClass = "text-blue-600 hover:underline";

  return (
    <nav className="bg-white shadow-md p-4 flex justify-between items-center max-w-6xl mx-auto">
      <h1 className="text-xl font-bold text-gray-800">Jason's Design Portfolio</h1>
      <div className="space-x-6 text-lg">
        <NavLink to="/" end className={({ isActive }) => isActive ? activeClass : normalClass}>
          Home
        </NavLink>
        <NavLink to="/projects" className={({ isActive }) => isActive ? activeClass : normalClass}>
          Projects
        </NavLink>
        <NavLink to="/resume" className={({ isActive }) => isActive ? activeClass : normalClass}>
          Resume
        </NavLink>
        <NavLink to="/contact" className={({ isActive }) => isActive ? activeClass : normalClass}>
          Contact Me
        </NavLink>
      </div>
    </nav>
  );
}
